<div class="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_auto] gap-4 lg:gap-8 items-center w-full">
  <div class="min-w-0">
    <div class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
      <h2 class="font-roboto shrink-0 text-base md:text-xl text-primary_text">
        Número de pedido o guía:
      </h2>

      <div class="relative w-full sm:w-[320px] max-w-full">
        <input
          type="text"
          [(ngModel)]="orderNumberSearched"
          (keyup)="valideButton()"
          (change)="valideButton()"
          (input)="onInput($event)"
          (keyup.enter)="consultOrder()"
          minlength="5"
          maxlength="35"
          class="w-full h-[42px] text-sm md:text-base rounded-lg border-[1.5px] border-primary px-4 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-primary/20 font-roboto pe-11"
          placeholder="Ej: TMMEX75907811"
          [ngClass]="{
            'border-primary': orderNumberValid,
            'border-red-500': !orderNumberValid
          }"
        />

        <svg
          *ngIf="!isLoading && !isDisabled"
          (click)="consultOrder()"
          xmlns="http://www.w3.org/2000/svg"
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          class="absolute top-1/2 -translate-y-1/2 right-3 cursor-pointer"
        >
          <path
            d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
            stroke="#1E3746"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M22 22L20 20"
            stroke="#1E3746"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <div
          *ngIf="isLoading"
          class="animate-spin rounded-full h-5 w-5 border-t-4 border-secondary absolute top-1/2 -translate-y-1/2 right-4"
        ></div>
      </div>
    </div>

    <div
      *ngIf="!orderNumberValid"
      class="flex text-red-500 items-center mt-1 sm:ms-[226px] space-x-2"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M7.9987 14.6654C11.6654 14.6654 14.6654 11.6654 14.6654 7.9987C14.6654 4.33203 11.6654 1.33203 7.9987 1.33203C4.33203 1.33203 1.33203 4.33203 1.33203 7.9987C1.33203 11.6654 4.33203 14.6654 7.9987 14.6654Z" stroke="#E62D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.11328 9.88661L9.88661 6.11328" stroke="#E62D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9.88661 9.88661L6.11328 6.11328" stroke="#E62D2D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Número no encontrado, intenta de nuevo</span>
    </div>
  </div>

  <div class="text-start lg:text-end lg:min-w-[360px]">
    <h3 class="text-primary_text font-semibold text-base md:text-xl lg:text-2xl leading-tight">
      No. Pedido: <span class="text-secondary_text">{{ orderNumber }}</span>
    </h3>
    <h3 class="text-sm md:text-lg lg:text-xl text-primary mt-1 leading-tight">
      Total productos comprados: {{ itemsQuantity }}
    </h3>
  </div>
</div>
